import Head from 'next/head'
import { useState, useEffect } from 'react'
import { Accordion } from 'react-accessible-accordion'
import { Fade } from 'react-awesome-reveal'
import removeMd from 'remove-markdown'

import { FaqAccordionItem } from '@/components/atomic/FaqAccordionItem'
import { Loader } from '@/components/atomic/Loader'
import { constants, FILTER_VEHICLE_TYPES_VANS } from '@/lib/constants'

export const Faqs = ({ vehicleType, status, faqList, activeFaqs, setActiveFaqs, title }) => {
  const [preExpanded, setPreExpanded] = useState(activeFaqs)

  useEffect(() => {
    setPreExpanded(activeFaqs)
  }, [activeFaqs])

  useEffect(() => {
    if (faqList.length > 0 && activeFaqs.length === 0) {
      setPreExpanded([faqList[0].slug])
    }
  }, [faqList, activeFaqs])

  return (
    <>
      {status === constants.componentStatus.COMPLETE && faqList.length > 0 && (
        <Head>
          <script type="application/ld+json">
            {`
              {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [${faqList.map(faq => {
                  return JSON.stringify({
                    '@type': 'Question',
                    name: `${faq.title}`,
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: `${removeMd(faq.body)}`,
                    },
                  })
                })}]
              }
            `}
          </script>
        </Head>
      )}
      <Fade>
        <section className="row">
          <div className="col-12">
            <h2>
              {title
                ? title
                : `${vehicleType === FILTER_VEHICLE_TYPES_VANS ? 'Van' : 'Car'} Leasing FAQs`}
            </h2>
            {status === constants.componentStatus.LOADING && (
              <div className="d-flex justify-content-center">
                <Loader />
              </div>
            )}
            {status === constants.componentStatus.COMPLETE && faqList.length > 0 && (
              <Accordion
                preExpanded={preExpanded}
                onChange={value => setActiveFaqs(value)}>
                {faqList.map(faq => (
                  <FaqAccordionItem
                    item={faq}
                    key={faq.slug}
                    isActive={preExpanded.includes(faq.slug)}
                  />
                ))}
              </Accordion>
            )}
            {status === constants.componentStatus.ERROR && (
              <div
                className="alert alert-warning my-3"
                role="alert">
                There has been an issue fetching the FAQs. Please try again later.
              </div>
            )}
          </div>
        </section>
      </Fade>
    </>
  )
}
